import { formatMuiErrorMessage } from '@mui/utils';
import React, { useRef, useEffect } from 'react';
import IHome from '../../interfaces/IHome';
import BaufiLeadApi from '../../utils/BaufiLeadApi';
import BaufiSmartApi, { ILoanOffer } from '../../utils/BaufiSmartApi';
import { ILoanRequestAddSubmit } from '../../utils/LoanRequest';
import LoadingError from '../LoadingError';
import LoadingIndicator from '../LoadingIndicator';
import createToast from '../MaterialUi/Toast';
import Calculator, { ICalculatorValues } from './Calculator';
import styles from './LoanGetBanks.scss';
import LogoPSD from '../../assets/img/psd_bank.svg';
import { classicNameResolver } from 'typescript';

export interface ILoanGetBanksProps {
    onNextStep: (data: any) => void;
    onPreviousStep: () => void;

    data: ILoanRequestAddSubmit;
}

const LoanGetBanks: React.FC<React.PropsWithChildren<ILoanGetBanksProps>> = ({ data, onNextStep = () => {}, onPreviousStep = () => {} }) => {
    // const timer = useRef(null);

    // useEffect(() => {
    //     timer.current = setTimeout(() => {
    //         onNextStep(null);
    //     }, 2500);

    //     return () => {
    //         clearTimeout(timer.current);
    //     };
    // }, []);

    useEffect(() => {
        const startTime = Date.now();

        BaufiSmartApi.getBanks(data)
            .then((res) => {
                setTimeout(() => {
                    onNextStep(res);
                }, Math.max(0, startTime + 2500 - Date.now())); // show spinner at least 2.5s
            })
            .catch((e) => {
                // createToast(<LoadingError error={e} />, 'error');
                createToast('Laden der Angebote fehlgeschlagen. Ein Berater wird Dich detailiert informieren.', 'info');
                console.error(e);
                setTimeout(() => {
                    onNextStep([]);
                }, Math.max(0, startTime + 2500 - Date.now())); // show spinner at least 2.5s
            });
    }, []);

    return (
        <div className={styles.loanGetBanks}>
            <LoadingIndicator />
        </div>
    );
};

export default LoanGetBanks;
